/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
document.addEventListener("DOMContentLoaded", function(event) {
    activarFrasesDestacadas();
});

function activarFrasesDestacadas(){
    $nextBtns = document.querySelectorAll('.bloque-estudio-frases-destacadas .next');
    if($nextBtns.length>0){
        for (let $i = 0; $i < $nextBtns.length; $i++) {
            const $nextBtn = $nextBtns[$i];
            $nextBtn.addEventListener('click', function(){
                $active = this.parentElement.parentElement.querySelector('.destacado.active');
                $numActive =  $active.getAttribute('data-order');                
                
                $frases = this.parentElement.parentElement.querySelectorAll('.destacado');
                $totalFrases = $frases.length;

                $nextFrase = parseInt($numActive);
                if($nextFrase>=$totalFrases){
                    $nextFrase = 0;
                }
                
                $active.classList.remove('active');
                $frases[$nextFrase].classList.add('active');

                this.parentElement.querySelector('.current').innerText = ($nextFrase + 1);
            });
            
        }
    }

    $prevBtns = document.querySelectorAll('.bloque-estudio-frases-destacadas .prev');
    if($prevBtns.length>0){
        for (let $i = 0; $i < $prevBtns.length; $i++) {
            const $prevBtn = $prevBtns[$i];
            $prevBtn.addEventListener('click', function(){
                $active = this.parentElement.parentElement.querySelector('.destacado.active');
                $numActive =  $active.getAttribute('data-order');                
                
                $frases = this.parentElement.parentElement.querySelectorAll('.destacado');
                $totalFrases = $frases.length;

                $nextFrase = parseInt($numActive) -1;
                
                if($nextFrase<1){
                    $nextFrase = $totalFrases - 1;
                }else{
                    $nextFrase--;
                }
                
                
                $active.classList.remove('active');
                $frases[$nextFrase].classList.add('active');

            });
            
        }
    }
    
}